import {
  User,
  Inspector,
  Supervisor,
  inspectionApplication,
  Admin,
} from "../entity";

export const parserUser = (item) => {
  const { id, name, email, role } = item;

  return User.fromJSON({
    id,
    name,
    email,
    role,
  });
};

export const parserInspector = (item) => {
  const {
    category,
    createdAt,
    dni,
    email,
    id,
    internalIdentifier,
    isActive,
    lastName,
    name,
    needsPasswordReset,
    role,
  } = item;

  return Inspector.fromJSON({
    category,
    createdAt,
    dni,
    email,
    id,
    internalIdentifier,
    isActive,
    lastName,
    name,
    needsPasswordReset,
    role,
  });
};
export const parserAdmin = (item) => {
  const {
    category,
    createdAt,
    dni,
    email,
    id,
    internalIdentifier,
    isActive,
    lastName,
    name,
    needsPasswordReset,
    role,
  } = item;

  return Admin.fromJSON({
    category,
    createdAt,
    dni,
    email,
    id,
    internalIdentifier,
    isActive,
    lastName,
    name,
    needsPasswordReset,
    role,
  });
};

export const parserInspectionApplications = (item) => {
  const {
    id,
    createdAt,
    inspector,
    currentStatus,
    endDate,
    establishmentCode,
    establishmentDirection,
    establishmentName,
    establishmentZone,
    inspectionRequestImages,
    inspectorCoordinates,
    inspectionEvents,
    inspectionExportZone,
    inspectionType,
    inspectorInternalCode,
    reasonForRejection,
    startDate,
    upCode,
    upPolygonCoordinates,
    upPolygonSize,
    upSquareDistance,
    inspectionStartDate,
    inspectionEndDate,
  } = item;

  return inspectionApplication.fromJSON({
    id,
    createdAt,
    inspector,
    currentStatus,
    endDate,
    establishmentCode,
    establishmentDirection,
    establishmentName,
    establishmentZone,
    inspectionRequestImages,
    inspectorCoordinates,
    inspectionEvents,
    inspectionExportZone,
    inspectionType,
    inspectorInternalCode,
    reasonForRejection,
    startDate,
    upCode,
    upPolygonCoordinates,
    upPolygonSize,
    upSquareDistance,
    inspectionStartDate,
    inspectionEndDate,
  });
};

export const parserSupervisor = (item) => {
  const {
    category,
    createdAt,
    dni,
    email,
    id,
    internalIdentifier,
    isActive,
    lastName,
    name,
    needsPasswordReset,
    role,
  } = item;

  return Supervisor.fromJSON({
    category,
    createdAt,
    dni,
    email,
    id,
    internalIdentifier,
    isActive,
    lastName,
    name,
    needsPasswordReset,
    role,
  });
};
